export default __webpack_public_path__ + "static/heroImage-5e23dad45ac3759f874f1fb4d3357773.png";